import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { Modal, TextField } from '@shopify/polaris'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

/**
 * 批量修改属性
 * @param {Boolean} isShow 是否显示弹窗
 * @param {String} field 当前批量修改的字段
 * @param {Function} onClose 关闭回调
 * @param {Function} onConfirm 确认回调
 * @returns
 */
const EditAttribute = ({ isShow, field, onClose, onConfirm }) => {
	const { t } = useTranslation()

	const [active, setActive] = useState(false)
	const [inputValue, setInputValue] = useState('')

	const attributeList = [
		{
			field: 'option_one',
			title: 'Change all selected variants option value',
			subTitle: 'Set a option value to apply to all selected variants'
		},
		{
			field: 'option_two',
			title: 'Change all selected variants option value',
			subTitle: 'Set a option value to apply to all selected variants'
		},
		{
			field: 'option_three',
			title: 'Change all selected variants option value',
			subTitle: 'Set a option value to apply to all selected variants'
		},
		{
			field: 'price',
			title: 'Change all selected variants price',
			subTitle: 'Set a price to apply to all selected variants'
		}
	]

	useEffect(() => {
		setActive(isShow)
	}, [isShow])

	// 关闭弹窗
	const closeModal = useCallback(() => {
		setInputValue('')
		onClose()
		// eslint-disable-next-line
	}, [active])

	// 当前修改字段项
	const currentAttribute = useMemo(() => {
		return _.find(attributeList, (item) => item.field === field)
		// eslint-disable-next-line
	}, [field])

	// 页面主体内容
	const pageContent = active ? (
		<Modal
			open={active}
			onClose={closeModal}
			title={t(currentAttribute.title)}
			primaryAction={{
				content: t('Apply'),
				disabled: !inputValue,
				onAction: () => {
					onConfirm(inputValue)
					closeModal()
				}
			}}
			secondaryActions={[
				{
					content: t('Cancel'),
					onAction: closeModal
				}
			]}
		>
			<Modal.Section>
				<TextField
					label={t('Set Value')}
					labelHidden
					onChange={(value) => setInputValue(value)}
					value={inputValue}
					helpText={t(currentAttribute.subTitle)}
				/>
			</Modal.Section>
		</Modal>
	) : null

	return pageContent
}

export default EditAttribute
